export default __webpack_public_path__ + "static/media/44.616981c1.png";